import React, { useEffect, useState } from "react";
import RootSocialLogIn from "container/account/socialLogin/RootSocialLogIn";
import RootLogIn from "container/account/logIn/RootLogIn";
import RootSignUp from "container/account/signUp/RootSignUp";
import { withStore } from "store/storeHandler";
import { useHistory } from "react-router-dom";
import { getEssentialUrl } from "lib/urlQueryParser";
import PropTypes from "prop-types";

RootAccount.propTypes = {
  query: PropTypes.shape({ next: PropTypes.string }).isRequired
};

function RootAccount(props) {
  const { query } = props;
  const { hasLoggedIn } = props;
  const [mode, setMode] = useState("socialLogIn");

  const history = useHistory();

  useEffect(() => {
    if (hasLoggedIn) history.replace(getEssentialUrl({ type: "opening" })());
  }, []);

  const toggleModeFn = () => {
    const newMode = mode === "emailLogIn" ? "emailSignUp" : "emailLogIn";
    setMode(newMode);
  };

  const goNextUrl = () => {
    const next = !query.next
      ? getEssentialUrl({ type: "opening" })()
      : query.next;
    history.replace(next);
  };

  const goToEmailPage = () => {
    setMode("emailLogIn");
  };

  const goToSocialPage = () => {
    setMode("socialLogIn");
  };

  return (
    <div>
      {mode === "socialLogIn" && (
        <RootSocialLogIn goToEmailPage={goToEmailPage} />
      )}
      {mode === "emailLogIn" && (
        <RootLogIn
          toggleModeFn={toggleModeFn}
          goNextUrl={goNextUrl}
          goToSocialPage={goToSocialPage}
        />
      )}
      {mode === "emailSignUp" && (
        <RootSignUp
          toggleModeFn={toggleModeFn}
          goNextUrl={goNextUrl}
          goToSocialPage={goToSocialPage}
        />
      )}
    </div>
  );
}

export default withStore({
  stateMap: { myAccount: ["hasLoggedIn"] }
})(RootAccount);
